
const Config = {
    websiteUrl: process.env.REACT_APP_WEBSITE_URL as string,
    apiDomain: process.env.REACT_APP_API_DOMAIN as string,

    routePrefix : process.env.REACT_APP_ROUTE_PREFIX as string,
    platformUrl:  process.env.REACT_APP_PLATFORM_URL as string,
    platformLoginUrl: process.env.REACT_APP_PLATFORM_LOGIN_URL as string,

    cdnDomain: process.env.REACT_APP_CDN_DOMAIN as string,
    fontsUrl: process.env.REACT_APP_FONTS_URL as string,

    cloudflareSiteKey: process.env.REACT_APP_CLOUDFLARE_SITE_KEY as string,
    googleClientId: process.env.REACT_APP_GOOGLE_CLIENT_ID as string,

    aiMockupDepthUrl: process.env.REACT_APP_API_MOCKUP_DEPTH as string,
    aiMockupProcessImageUrl : process.env.REACT_APP_API_MOCKUP_PROCESS_IMAGE as string,
    aiInpaintUrl: process.env.REACT_APP_API_INPAINT as string,
    aiSegmentationUrl: process.env.REACT_APP_API_AI_SEGMENTATION as string,

    libWasmUrl:  process.env.REACT_APP_LIB_WASM_URL as string,

    paypalClientId: process.env.REACT_APP_PAYPAL_CLIENT_ID as string,
    paypalEnv : process.env.REACT_APP_PAYPAL_ENV as string
}

export default Config ;